<div class="container is-flex is-column">

  <app-sidebar-card (click)="toggle(expander)">
    <div class="is-flex gap-8 is-align-center">
      <app-sidebar-card-label>{{ 'legrand-app.__LEG_COM_CONSO' | AsyncLang | async }}</app-sidebar-card-label>
    </div>

    <div class="is-flex gap-16 is-align-center">
      <app-sidebar-card-expand [id]="'consumption'" #expander></app-sidebar-card-expand>
    </div>
  </app-sidebar-card>


  <div [@expand]="expander.open ? 'open' : 'close'" class="is-flex is-column">
    <app-cp-compare-home-electricity></app-cp-compare-home-electricity>
    <app-cp-compare-home-cold-water></app-cp-compare-home-cold-water>
    <app-cp-compare-home-hot-water></app-cp-compare-home-hot-water>
    <app-cp-compare-home-gas></app-cp-compare-home-gas>
  </div>

</div>